// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const urshifu_single_strike_gmax: PokeData = {
  "id": 10226,
  "name": "urshifu-single-strike-gmax",
  "height": 290,
  "weight": 10000,
  "base_experience": 275,
  "types": [
    PokeType.FIGHTING,
    PokeType.DARK
  ],
  "api_moves": [],
  "moves": [
    "double-kick",
    "crunch",
    "lash-out",
    "phantom-force",
    "quash",
    "dark-pulse",
    "meteor-assault",
    "rolling-kick",
    "bite",
    "karate-chop",
    "pursuit",
    "jump-kick",
    "coaching"
  ],
  "evolution_chain": {
    "id": 470,
    "item": null,
    "species": [
      {
        "name": "kubfu",
        "order": 891,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "urshifu",
        "order": 892,
        "types": [
          PokeType.FIGHTING,
          PokeType.DARK
        ],
        "evolves_from_species_id": 891,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TOWER_OF_DARKNESS
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TOWER_OF_WATERS
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 122,
    "ability_power": 164
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
